import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get, isEmpty } from 'lodash';
import { FieldArray } from 'redux-form';
import AddOnsCards from '../guest/forms/fieldSets/AddOnsCards';
import { FormattedMessage } from 'react-intl';

export default class AddOns extends Component {
  componentDidMount () {
    const { spaceRental, contract, displayedAddOns, routeParams, isBrowseAddOns } = this.props;
    const listing = get(spaceRental, 'meta.listing', {});
    const pendingBookingContracts = get(contract, 'quote.pending.children', []);
    pendingBookingContracts.push(get(contract, 'quote.pending.master', {}));
    const bookingContracts = !isEmpty(pendingBookingContracts[0]) ? pendingBookingContracts : get(contract, 'contracts', {});
    analyticsIntegrations.messageTrack('guest update add-on form viewed', listing, bookingContracts, { origin: isBrowseAddOns ? 'inbox' : 'booking update form' }, displayedAddOns);
  }

  render () {
    const {
      dispatch,
      handleAddOnChange = null,
      formName = '',
      addOnsValues,
      spaceRental,
      displayAddOns,
      toggleModal,
      whichModal
    } = this.props;

    return (
      <div className="AddOns">
        <div className="text-gray-600 margin-xl-bottom">
          <FormattedMessage
            id="inbox_guest_update_booking.add_ons.select_items"
            defaultMessage="Select additional items to make your event complete."
          />
        </div>
        <FieldArray
          component={AddOnsCards}
          name="addOns"
          displayAddOns={displayAddOns}
          handleAddOnChange={handleAddOnChange}
          formName={formName}
          dispatch={dispatch}
          addOnsValues={addOnsValues}
          spaceRental={spaceRental}
          toggleModal={toggleModal}
          whichModal={whichModal}
        />
      </div>
    );
  }
}

AddOns.propTypes = {
  dispatch: PropTypes.func,
  handleAddOnChange: PropTypes.func,
  formName: PropTypes.string,
  addOnsValues: PropTypes.array,
  spaceRental: PropTypes.object,
  contract: PropTypes.object,
  displayedAddOns: PropTypes.array,
  routeParams: PropTypes.object,
  toggleModal: PropTypes.func,
  whichModal: PropTypes.string
};
